@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.config

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.analytics.AnalyticsConfigDto

object GetAnalyticsConfigEndpoint : EndPoint<GetAnalyticsConfigEndpoint.Request, GetAnalyticsConfigEndpoint.Response>() {
    class Request
    class Response(val config: AnalyticsConfigDto)
}
